import clsx from 'clsx';
import { IoLocationOutline } from 'react-icons/io5';
import { MdVerified } from 'react-icons/md';
import { useNavigate } from 'react-router';

import { AuthorizedImage } from '@/components/AuthorizedImage';
import { SERVICE_CATEGORIES } from '@pages/DockagePage/helpers/serviceCategories';

import type { ProviderCard } from './equipment-ai-chat.types';
import s from './EquipmentAIChat.module.scss';

interface Props {
  provider: ProviderCard;
}

const EquipmentChatProviderCard = ({ provider }: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    void navigate(`/service-providers/${provider.id}`);
  };

  const categoryLabels = provider.categories
    .map((catId) => {
      const found = SERVICE_CATEGORIES.find((c) => c.id === catId);
      return found ? found.title : catId.replace(/_/g, ' ');
    })
    .slice(0, 3);

  return (
    <button className={s.providerCard} onClick={handleClick} type="button">
      <div className={s.providerCardHead}>
        {provider.logo ? (
          <AuthorizedImage src={provider.logo} alt="" className={s.providerLogo} />
        ) : (
          <div className={s.providerLogoFallback}>{provider.name.charAt(0).toUpperCase()}</div>
        )}
        <div className={s.providerMeta}>
          <span className={clsx(s.providerName, 'accent-small')}>
            {provider.name}
            {provider.verified && <MdVerified className={s.verifiedIcon} title="Verified" />}
          </span>
          {provider.short_description && (
            <span className={s.providerShortDesc}>{provider.short_description}</span>
          )}
        </div>
      </div>
      {provider.distance_km != null && (
        <div className={s.providerDistance}>
          <IoLocationOutline />
          {provider.distance_km.toFixed(1)} km away
        </div>
      )}
      {categoryLabels.length > 0 && (
        <div className={s.providerCategories}>
          {categoryLabels.map((label) => (
            <span key={label} className={s.providerCategory}>
              {label}
            </span>
          ))}
        </div>
      )}
    </button>
  );
};

export default EquipmentChatProviderCard;
